import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleStructureTypesConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleStructureTypes";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_STRUCTURE_TYPES = "DeleteMultipleprojectCycleStructureTypes";
    static FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_STRUCTURE_TYPES = "UploadprojectCycleStructureTypes";
}
